import { Link } from 'react-router-dom';
import { NAV_LINKS } from '../../lib/constants';
import type { SiteSettings } from '../../types';
import styles from './PublicFooter.module.css';

interface PublicFooterProps {
  settings: SiteSettings;
}

export function PublicFooter({ settings }: PublicFooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brand}>
          <span className={styles.orgName}>{settings.display_name}</span>
          {settings.address && <p className={styles.address}>{settings.address}</p>}
          {settings.contact_email && (
            <a href={`mailto:${settings.contact_email}`} className={styles.contact}>
              {settings.contact_email}
            </a>
          )}
          {settings.phone && (
            <a href={`tel:${settings.phone}`} className={styles.contact}>
              {settings.phone}
            </a>
          )}
        </div>

        <nav className={styles.nav} aria-label="Footer navigation">
          {NAV_LINKS.map((link) => (
            <Link key={link.path} to={link.path} className={styles.navLink}>
              {link.label}
            </Link>
          ))}
        </nav>

        {settings.social_links?.facebook && (
          <div className={styles.social}>
            <a
              href={settings.social_links.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Facebook"
            >
              Facebook
            </a>
          </div>
        )}
      </div>

      <div className={styles.bottom}>
        <div className="container">
          <p>{settings.footer_text}</p>
        </div>
      </div>
    </footer>
  );
}
